var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOragenode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.175293 7.3099H4.84196M4.84196 7.3099C4.84196 6.69106 5.08779 6.09756 5.52538 5.65998C5.96296 5.22239 6.55645 4.97656 7.17529 4.97656C7.79413 4.97656 8.38762 5.22239 8.82521 5.65998C9.26279 6.09756 9.50863 6.69106 9.50863 7.3099M4.84196 7.3099C4.84196 7.92873 5.08779 8.52223 5.52538 8.95981C5.96296 9.3974 6.55645 9.64323 7.17529 9.64323C7.79413 9.64323 8.38762 9.3974 8.82521 8.95981C9.26279 8.52223 9.50863 7.92873 9.50863 7.3099M9.50863 7.3099H14.1753",
    stroke: "#FD9A00",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOragenode);
export default __webpack_public_path__ + "static/media/oragenode.5c4403746abbbc214e064945fa989f31.svg";
export { ForwardRef as ReactComponent };